import React, { forwardRef } from 'react';

import { quizMessages } from '../../../translates/quizMessages';
import { useIntlReexport } from '../../hooks/useIntlReexport';
import { ModalPopup } from '../modal/ModalPopup';
import { Button, ButtonVariant, Checkbox } from '@ael/shared-components-library';

import './introduction-modal.scss';

interface IntroductionModalProps {
  graphic: React.ReactElement;
  text?: string;
  displayDontShowAgain: boolean;
  buttonLabel: string;
  header: string;

  onClick: (dontShowAgain: boolean) => void;
}

export const IntroductionModal = forwardRef((props: IntroductionModalProps, ref: React.Ref<HTMLDivElement>) => {
  const { formatMessage } = useIntlReexport();
  const [dontShowAgainChecked, setdontShowAgainChecked] = React.useState(false);

  const toggleDontShowAgain = () => {
    setdontShowAgainChecked((old) => !old);
  };

  return (
    <ModalPopup ref={ref}>
      <div className="introduction-modal">
        <div className="introduction-modal--placeholder" />
        <div className="introduction-modal--content">
          <div className="introduction-modal-content--graphic">{props.graphic}</div>
          <div className="introduction-modal-content--description">
            {props.header && <div className="introduction-modal-content--header">{props.header}</div>}
            <div className="introduction-modal-content--text">{props.text}</div>
          </div>
          <Button variant={ButtonVariant.SUCCESS} onClick={() => props.onClick(dontShowAgainChecked)}>
            {props.buttonLabel}
          </Button>
        </div>
        <div className="introduction-modal--footer">
          {props.displayDontShowAgain && (
            <div className="introduction-modal-footer--checkbox">
              <Checkbox
                label={formatMessage(quizMessages.dontShowAgain)}
                onClick={toggleDontShowAgain}
                value={dontShowAgainChecked}
              />
            </div>
          )}
        </div>
      </div>
    </ModalPopup>
  );
});
